import {
  EUserInventoryResourceKind,
  type IUserInventoryColumn,
  type TUserInventoryHoldingKind,
  type TUserInventoryIdleDays,
  type TUserInventorySortBy,
  type TUserInventorySortOrder,
  type TUserInventoryUseVerb,
} from "../types/token-usage-user-inventory";

// NOTE: NSAI-8010 — the idle windows an owner can pick; the server accepts
// exactly these.
export const USER_INVENTORY_IDLE_DAYS_OPTIONS: readonly TUserInventoryIdleDays[] =
  [30, 60, 90];
export const DEFAULT_USER_INVENTORY_IDLE_DAYS: TUserInventoryIdleDays = 30;

export const DEFAULT_USER_INVENTORY_SORT_BY: TUserInventorySortBy = "agents";
export const DEFAULT_USER_INVENTORY_SORT_ORDER: TUserInventorySortOrder =
  "desc";

// NOTE: labelKey resolves against the "settings" namespace.
export const USER_INVENTORY_COLUMNS = [
  {
    sortBy: "agents",
    labelKey: "tokenCostUsage.userAnalytics.inventory.columns.agents",
  },
  {
    sortBy: "webhooks",
    labelKey: "tokenCostUsage.userAnalytics.inventory.columns.webhooks",
  },
  {
    sortBy: "hooks",
    labelKey: "tokenCostUsage.userAnalytics.inventory.columns.hooks",
  },
  {
    sortBy: "workflows",
    labelKey: "tokenCostUsage.userAnalytics.inventory.columns.workflows",
  },
  {
    sortBy: "assistants",
    labelKey: "tokenCostUsage.userAnalytics.inventory.columns.assistants",
  },
  {
    sortBy: "dashboards",
    labelKey: "tokenCostUsage.userAnalytics.inventory.columns.dashboards",
  },
  {
    sortBy: "chats",
    labelKey: "tokenCostUsage.userAnalytics.inventory.columns.chats",
  },
] as const satisfies readonly IUserInventoryColumn[];

// NOTE: The kinds a person can own, in the order the "Owns" cell, the idle
// breakdown and the expanded row list them. Every one of them can sit idle.
export const USER_INVENTORY_HOLDING_KINDS: readonly TUserInventoryHoldingKind[] =
  ["agents", "assistants", "dashboards", "workflows", "hooks", "webhooks"];

// NOTE: How many resources of a kind, and how many integrations, the expanded
// row shows before "Show all". The server sends up to 50 of each kind.
export const USER_INVENTORY_DETAILS_PREVIEW_COUNT = 5;

export const USER_INVENTORY_RESOURCE_USE_VERBS = {
  [EUserInventoryResourceKind.AGENT]: "run",
  [EUserInventoryResourceKind.WORKFLOW]: "run",
  [EUserInventoryResourceKind.HOOK]: "triggered",
  [EUserInventoryResourceKind.WEBHOOK]: "triggered",
  [EUserInventoryResourceKind.ASSISTANT]: "used",
  [EUserInventoryResourceKind.DASHBOARD]: "used",
} as const satisfies Record<EUserInventoryResourceKind, TUserInventoryUseVerb>;

// NOTE: The plural label each kind's group is headed by in the expanded row.
export const USER_INVENTORY_RESOURCE_KIND_COLUMNS = {
  [EUserInventoryResourceKind.AGENT]: "agents",
  [EUserInventoryResourceKind.ASSISTANT]: "assistants",
  [EUserInventoryResourceKind.DASHBOARD]: "dashboards",
  [EUserInventoryResourceKind.WORKFLOW]: "workflows",
  [EUserInventoryResourceKind.HOOK]: "hooks",
  [EUserInventoryResourceKind.WEBHOOK]: "webhooks",
} as const satisfies Record<
  EUserInventoryResourceKind,
  TUserInventoryHoldingKind
>;
